function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { SubscriptionRejectedError, SubscriptionTimeoutError, DisconnectedError } from "../protocol/index.js";
import { stringifyParams } from "../stringify-params/index.js";
import { NoopLogger } from "../logger/index.js";
var commandID = 0;
export var ActionCableProtocol = /*#__PURE__*/function () {
  function ActionCableProtocol() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ActionCableProtocol);

    var logger = opts.logger;
    this.logger = logger || new NoopLogger();
    this.pendingSubscriptions = {};
    this.pendingUnsubscriptions = {}; // For how long to wait before sending `subscribe` command
    // in case `unsubscribe` was sent for the same identifier

    this.subscribeCooldownInterval = opts.subscribeCooldownInterval || 250; // For how long to wait for subscription acknoledgement before trying again
    // (just once).

    this.subscribeRetryInterval = opts.subscribeRetryInterval || 5000;
  }

  _createClass(ActionCableProtocol, [{
    key: "attached",
    value: function attached(cable) {
      this.cable = cable;
    }
  }, {
    key: "subscribe",
    value: function subscribe(channel, params) {
      var _this = this;

      var subscriptionPayload = {
        channel: channel
      };

      if (params) {
        Object.assign(subscriptionPayload, params);
      }

      var identifier = stringifyParams(subscriptionPayload);

      if (this.pendingUnsubscriptions[identifier]) {
        var cooldown = this.subscribeCooldownInterval * 1.5;
        this.logger.debug("unsubscribed recently, cooldown for ".concat(cooldown), identifier);
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(_this.subscribe(channel, params));
          }, cooldown);
        });
      }

      if (this.pendingSubscriptions[identifier]) {
        this.logger.warn('subscription is already pending, skipping', identifier);
        return Promise.reject(Error('Already subscribing'));
      }

      var retryInterval = this.subscribeRetryInterval;
      return new Promise(function (resolve, reject) {
        var id = ++commandID;
        _this.pendingSubscriptions[identifier] = {
          resolve: resolve,
          reject: reject,
          id: id
        };

        _this.cable.send({
          command: 'subscribe',
          identifier: identifier
        });

        _this.maybeRetrySubscribe(id, identifier, retryInterval);
      });
    }
  }, {
    key: "maybeRetrySubscribe",
    value: function maybeRetrySubscribe(id, identifier, retryInterval) {
      var _this2 = this;

      setTimeout(function () {
        var sub = _this2.pendingSubscriptions[identifier];
        if (!sub) return;
        if (sub.id !== id) return;

        _this2.logger.warn("no subscription ack received in ".concat(retryInterval, "ms, retrying subscribe"), identifier);

        _this2.cable.send({
          command: 'subscribe',
          identifier: identifier
        });

        _this2.maybeExpireSubscribe(id, identifier, retryInterval);
      }, retryInterval);
    }
  }, {
    key: "maybeExpireSubscribe",
    value: function maybeExpireSubscribe(id, identifier, retryInterval) {
      var _this3 = this;

      setTimeout(function () {
        var sub = _this3.pendingSubscriptions[identifier];
        if (!sub) return;
        if (sub.id !== id) return;
        delete _this3.pendingSubscriptions[identifier];
        sub.reject(new SubscriptionTimeoutError("Haven't received subscription ack in ".concat(retryInterval * 2, "ms for ").concat(identifier)));
      }, retryInterval);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(identifier) {
      var _this4 = this;

      this.cable.send({
        command: 'unsubscribe',
        identifier: identifier
      });
      this.pendingUnsubscriptions[identifier] = true;
      setTimeout(function () {
        delete _this4.pendingUnsubscriptions[identifier];
      }, this.subscribeCooldownInterval);
      return Promise.resolve();
    }
  }, {
    key: "perform",
    value: function perform(identifier, action, payload) {
      if (!payload) {
        payload = {};
      }

      payload.action = action;
      this.cable.send({
        command: 'message',
        identifier: identifier,
        data: JSON.stringify(payload)
      });
      return Promise.resolve();
    }
  }, {
    key: "receive",
    value: function receive(msg) {
      /* eslint-disable consistent-return */
      if (_typeof(msg) !== 'object') {
        this.logger.error('unsupported message format', {
          message: msg
        });
        return;
      }

      var type = msg.type,
          identifier = msg.identifier,
          message = msg.message,
          reason = msg.reason,
          reconnect = msg.reconnect;
      if (type === 'ping') return this.cable.keepalive(msg.message);

      if (type === 'welcome') {
        return this.cable.connected();
      }

      if (type === 'disconnect') {
        var err = new DisconnectedError(reason);
        this.reset(err);

        if (reconnect === false) {
          this.cable.closed(err);
        } else {
          this.cable.disconnected(err);
        }

        return;
      }

      if (type === 'confirm_subscription') {
        var subscription = this.pendingSubscriptions[identifier];

        if (!subscription) {
          this.logger.error('subscription not found, unsubscribing', {
            type: type,
            identifier: identifier
          });
          this.unsubscribe(identifier);
          return;
        }

        delete this.pendingSubscriptions[identifier];
        return subscription.resolve(identifier);
      }

      if (type === 'reject_subscription') {
        var _subscription = this.pendingSubscriptions[identifier];

        if (!_subscription) {
          return this.logger.error('subscription not found', {
            type: type,
            identifier: identifier
          });
        }

        delete this.pendingSubscriptions[identifier];
        return _subscription.reject(new SubscriptionRejectedError());
      }

      if (message) {
        return {
          identifier: identifier,
          message: message
        };
      }

      this.logger.warn("unknown message type: ".concat(type), {
        message: msg
      });
    }
  }, {
    key: "reset",
    value: function reset(err) {
      // Reject pending subscriptions
      for (var identifier in this.pendingSubscriptions) {
        this.pendingSubscriptions[identifier].reject(err);
      }

      this.pendingSubscriptions = {};
    }
  }, {
    key: "recoverableClosure",
    value: function recoverableClosure() {
      return false;
    }
  }]);

  return ActionCableProtocol;
}();